import { FiX } from "react-icons/fi"
import styled from "styled-components"

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  transition: all 0.3s ease-in;
  display: ${({ show }) => (show ? "flex" : "none")};
  background: rgba(0, 0, 0, 0.4);
  align-items: ${({ position }) =>
    position === "top" ? "flex-start" : "center"};
  justify-content: center;
  box-sizing: border-box;
  overflow: auto;
  z-index: 4000;
  & ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  & ::-webkit-scrollbar-track {
    background: rgba(57, 57, 57, 0.8);
    border-radius: 2px;
  }

  & ::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 2px;
  }

  & ::-webkit-scrollbar-thumb:hover {
    background: #636262;
    border-radius: 2px;
  }
`

export const Content = styled.div`
  background: ${({ transparent, background }) =>
    !transparent && (background || "white")};
  border-radius: ${({ rounded }) => rounded && "10px"};
  box-shadow: black;
  /* margin-top: ${({ position }) => (position === "top" ? "2rem" : "0")}; */
  margin-left: 0.8rem;
  margin-right: 0.8rem;
  box-shadow: ${({ transparent }) =>
    !transparent && "-4px 1px 22px -6px rgba(0, 0, 0, 0.36)"};
  overflow: ${({ overflow }) => (overflow ? "unset" : "hidden")};
  max-width: ${({ maxWidth }) => maxWidth || "unset"};
  width: ${(props) => (props.maxWidth ? "-webkit-fill-available" : "unset")};
  animation: ${(props) =>
    props.open ? "modal2 0.2s alternate" : "modal 0.4s alternate"};

  @keyframes modal {
    from {
      transform: scale(0.25);
      opacity: 0;
    }

    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes modal2 {
    from {
      transform: scale(1);
      opacity: 1;
    }
    to {
      transform: scale(0.25);
      opacity: 0;
    }
  }
`

export const Header = styled.div`
  height: 55px;
  border-radius: 8px 8px 0px 0px;
  background: ${({ background }) => background || "white"};
  display: ${({ visiblity }) => (visiblity ? "flex" : "none")};
  border-bottom: 1px solid #ebebf3;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
`

export const Title = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ background }) => background && "white"};
`

export const CloseButton = styled.button`
  padding: 0;
  margin: 0;
  color: ${({ background }) => background && "white"};
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border: none;
  overflow: hidden;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  transition: 0.5s;
  &:focus {
    outline: none;
    background: ${({ background }) => !background && "#f8f8f8"};
  }
  &:hover {
    transform: scale(1.3);
    background: ${({ background }) => !background && "#f8f8f8"};
  }
`

export const Body = styled.div`
  position: relative;
  max-height: ${({ maxHeight }) => maxHeight || "unset"};
  overflow: ${({ overflow }) => (overflow ? overflow : "hidden scroll")};
  &::-webkit-scrollbar-track {
    margin-bottom: 10px;
  }
`

export const CloseIcon = styled(FiX)``
